import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import TriggerModal from "./TriggerModal";
import SelectedTriggerItem from "./../form/SelectedTriggerItem";
import DataSourceModal from "./DataSourceModal";
import { FaFile } from "react-icons/fa6";
import { getFileIcon } from "../chat/AttachmentIcon";

const IntegrationModal = ({
  integrationData,
  selectedIntegrationAppOptions,
  setSelectedIntegrationAppOptions,
  selectedDataSourceFiles, setSelectedDataSourceFiles,
  onClose,
}) => {
  const [isIntegrationModalOpen, setIsIntegrationModalOpen] = useState(false);
  const [editOption, setEditOption] = useState(null);
  const [selectDataSourceOptions, setSelectDataSourceOptions] = useState([]);
  const [isDataSourceSelectionModalOpen, setIsDataSourceSelectionModalOpen] =
    useState(false);
  // const [selectedDataSourceFiles, setSelectedDataSourceFiles] = useState([]);

  const handleIntegrationEditOption = (option) => {
    setEditOption(option);
    setIsIntegrationModalOpen(true);
  };
  const handleDataSourceModalClose = () => {
    setIsDataSourceSelectionModalOpen(false);
  };

  const handleDeleteIntegrationOption = (optionId) => {
    setSelectedIntegrationAppOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };

  return (
    <div className="fixed top-0 left-0 bg-black bg-opacity-20 backdrop-blur-sm w-screen h-screen items-center justify-center z-[100] transition-all ease-in-out duration-200 flex">
      <div className="bg-1 h-[90%] max-w-3xl w-[90%] rounded-lg overflow-auto">
        <div className="flex justify-between border-b border-zinc-800 px-3 py-5">
          <h1 className="text-xl font-bold">App Integrations and Data Sources</h1>
          <button
            onClick={() => onClose()}
            className="bg-1 transition-all duration-200 rounded-lg p-1.5"
          >
            <IoMdClose className="text-white" />
          </button>
        </div>
        <div className="flex flex-col gap-8 p-6">
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between bg-zinc-950 px-3 py-2 rounded-lg">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">App integrations</h1>
                <p className="text-sm text-p-text">
                  Add applications included in the workflow
                </p>
              </div>
              <button
                onClick={() => setIsIntegrationModalOpen(true)}
                className="px-2 py-1 border border-zinc-200 duration-200 transition-all text-sm rounded-lg"
              >
                ADD
              </button>
            </div>
            {selectedIntegrationAppOptions.map((item) => (
              <SelectedTriggerItem
                key={item.id} // Ensure `id` is unique
                item={item}
                handleEditOption={() => handleIntegrationEditOption(item)}
                handleDeleteOption={() => handleDeleteIntegrationOption(item.id)}
              />
            ))}
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between gap-3 bg-zinc-950 px-3 py-2 rounded-lg">
              <div className="flex flex-col gap-1 ">
                <h1 className="text-base font-semibold">Data sources</h1>
                <p className="text-sm">
                  Add data sources required in the workflow
                </p>
              </div>
              <button
                onClick={() => setIsDataSourceSelectionModalOpen(true)}
                className="px-2 py-1 border border-zinc-200 duration-200 transition-all text-sm rounded-lg"
              >
                ADD
              </button>
            </div>
            {
              <ul className="flex flex-wrap gap-2">
                {selectedDataSourceFiles.length > 0 &&
                  selectedDataSourceFiles.map((file, idx) => (
                    <li
                      key={idx}
                      className="bg-zinc-100 text-zinc-800 px-3 py-1.5 rounded-full text-sm text-s-text"
                    >
                      <div className="flex items-center gap-2 max-w-[70%]">
                        {/* <FaFile className="text-white" /> */}
                        {getFileIcon(file.original_filename)}
                        <span
                          className="text-sm truncate cursor-pointer hover:whitespace-normal hover:overflow-visible hover:max-w-none transition-all"
                          title={`${file.original_filename}\nUploaded at: ${file.timestamp}`}
                        >
                          {file.original_filename}
                        </span>
                      </div>
                    </li>
                  ))}
              </ul>
            }
          </div>
        </div>
      </div>

      {isIntegrationModalOpen && (
        <TriggerModal
          title="Add integration"
          desc="Select the app you’d like to add as integration."
          isOpen={isIntegrationModalOpen}
          onClose={() => {
            setIsIntegrationModalOpen(false);
            setEditOption(null);
          }}
          appsData={integrationData}
          selectedOptions={selectedIntegrationAppOptions}
          setSelectedOptions={setSelectedIntegrationAppOptions}
          editOption={editOption}
        />
      )}
      {isDataSourceSelectionModalOpen && (
              <DataSourceModal closeModal={handleDataSourceModalClose} setSelectedDataSourceFiles={setSelectedDataSourceFiles} selectedDataSourceFiles={selectedDataSourceFiles} />
      )}
    </div>

  );
};

export default IntegrationModal;
